import { emitDirectoryLoadedTelemetry, } from '#telemetry';
export const readDirContents = async ({ browserInstance, filespaceId, lucidSdk, queryClient, queryKey, read, workspaceId, }) => {
    // Only the first read of a directory is a load: polling and remounts refetch cached contents
    const isFirstLoad = queryClient.getQueryData(queryKey) === undefined;
    const loadStart = Date.now();
    const contents = await read();
    if (isFirstLoad && browserInstance) {
        emitDirectoryLoadedTelemetry(lucidSdk, {
            browserInstance,
            entryCount: contents.length,
            filespaceId,
            loadDurationMs: Date.now() - loadStart,
            workspaceId,
        });
    }
    return contents;
};
